import React from 'react';

import { useAccountsMapping } from 'src/services/accountsMapping';
import { useJiraContext } from 'src/services/jira';
import { useSession } from 'src/services/session';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import Tabs from 'src/views/components/Tabs';

import TabContent from '../components/TabContent';
import JiraServer from '../Legacy/JiraServer';

import CreateAccountsMapping from './CreateAccountsMapping';
import MainLogin from './MainLogin';

const ConfigWithoutAccountsMapping = () => {
  const [, accountsMappingLoading, accountsMappingError] = useAccountsMapping();
  const jiraContext = useJiraContext();
  const session = useSession();

  const SetupTab = () => {
    const loading = session.loading || !jiraContext.context || accountsMappingLoading;
    const error = session.error || jiraContext.error || accountsMappingError;

    if (error) return <ErrorMessage error={['Can not load configuration form', error]}/>;
    if (loading) return <CenteredSpinner size="large"/>;

    if (session.loggedIn) {
      return <CreateAccountsMapping/>;
    } else {
      return <MainLogin/>;
    }
  };

  return (
    <div>
      <Tabs
        rememberTabKey="integration_jira_tabs_admin_main"
        tabs={[
          { label: 'Configure Jira <--> PagerDuty Integration', content: <TabContent><SetupTab/></TabContent> },
          { label: 'Legacy (add-on v3) Integration', content: <TabContent><JiraServer/></TabContent> },
        ]}
      />
    </div>
  );
};


export default ConfigWithoutAccountsMapping;
